import { useEffect, useState } from "react";
import { NavLink, Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
import Logo from "./Logo";

const links = [
  { to: "/", label: "Acasă", testid: "nav-home" },
  { to: "/servicii", label: "Servicii", testid: "nav-services" },
  { to: "/preturi", label: "Prețuri", testid: "nav-pricing" },
  { to: "/rezervari", label: "Rezervări", testid: "nav-reservations" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  return (
    <header
      data-testid="site-navbar"
      className="fixed top-0 left-0 right-0 z-50 transition-all duration-500"
      style={{
        backgroundColor: scrolled ? "rgba(255,255,255,0.92)" : "rgba(255,255,255,0.75)",
        backdropFilter: "blur(14px)",
        WebkitBackdropFilter: "blur(14px)",
        borderBottom: scrolled ? "1px solid #E8E0D5" : "1px solid transparent",
      }}
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-12">
        <div className="grid grid-cols-3 items-center" style={{ height: scrolled ? 72 : 92, transition: "height 0.5s ease" }}>
          {/* Left links (desktop) */}
          <nav className="hidden md:flex items-center gap-9">
            {links.slice(0, 2).map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                data-testid={l.testid}
                end={l.to === "/"}
                className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`}
              >
                {l.label}
              </NavLink>
            ))}
          </nav>

          {/* Center logo */}
          <div className="flex justify-start md:justify-center">
            <Logo compact={scrolled} />
          </div>

          {/* Right links + CTA */}
          <nav className="hidden md:flex items-center justify-end gap-9">
            {links.slice(2).map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                data-testid={l.testid}
                className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`}
              >
                {l.label}
              </NavLink>
            ))}
            <Link to="/rezervari" data-testid="navbar-cta-book" className="btn-lux" style={{ padding: "0.7rem 1.4rem", fontSize: "0.68rem" }}>
              Programează-te
            </Link>
          </nav>

          {/* Mobile menu trigger */}
          <button
            data-testid="mobile-menu-toggle"
            onClick={() => setOpen((o) => !o)}
            className="md:hidden col-start-3 justify-self-end p-2"
            aria-label="Deschide meniul"
          >
            {open ? <X size={20} color="#1A1A1A" /> : <Menu size={20} color="#1A1A1A" />}
          </button>
        </div>
      </div>

      {/* Mobile drawer */}
      <div
        data-testid="mobile-menu"
        className="md:hidden overflow-hidden transition-[max-height] duration-500 ease-in-out"
        style={{
          maxHeight: open ? "100vh" : "0px",
          backgroundColor: "#FFFFFF",
          borderTop: open ? "1px solid #E8E0D5" : "none",
        }}
      >
        <div className="px-8 py-10 flex flex-col gap-7">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              onClick={() => setOpen(false)}
              data-testid={`${l.testid}-mobile`}
              className={({ isActive }) =>
                `font-serif-display text-3xl ${isActive ? "" : ""}`
              }
              style={({ isActive }) => ({
                color: isActive ? "#B8964E" : "#1A1A1A",
                fontWeight: 300,
              })}
            >
              {l.label}
            </NavLink>
          ))}
          <Link
            to="/rezervari"
            onClick={() => setOpen(false)}
            data-testid="mobile-cta-book"
            className="btn-lux mt-4 self-start"
          >
            Programează-te
          </Link>
        </div>
      </div>
    </header>
  );
}
